/*
  
*/
var ENMergeDateRangeRefiner = require('../EN/ENMergeDateRangeRefiner').Refiner;

exports.Refiner = function JPMergeDateRangeRefiner() {
    ENMergeDateRangeRefiner.call(this);

    this.pattern = function () { return /^\s*(から|ー)\s*$/i };
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/chrono-node/src/refiners/JP/JPMergeDateRangeRefiner.js
// module id = 1135
// module chunks = 0